module.exports = __webpack_public_path__ + "static/media/vf_wsneakers_core.2813a9e2.svg";